import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';

export const useAccountingCategoryOptions = (ids?: string[]) => {
    const enterpriseId = useCurrentEnterpriseId();
    const query = useRepositorySuspenseQuery(
        'accountingCategories',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
        },
        {
            select: ({ accountingCategories }) =>
                accountingCategories
                    ? pipe(
                          accountingCategories,
                          array.filterMap((category) =>
                              category.isActive && (!ids || ids.includes(category.id))
                                  ? option.some(
                                        createOption({
                                            label: category.name,
                                            value: category.id,
                                        })
                                    )
                                  : option.none
                          )
                      )
                    : [],
        }
    );

    return query.data;
};
